let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dOM9P")).then(() => parcelRequire('lu78M'));